module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v("select your Pokémon")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.players), function(player) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_c('div', {
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.select(player)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h3', [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Health: " + _vm._s(player.health))]), _vm._v(" "), _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Agility: " + _vm._s(player.agility))]), _vm._v(" "), _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Defense: " + _vm._s(player.defense))])])]), _vm._v(" "), _c('div', {
      staticClass: "container-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.apiUrl + player.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [(player.attacks) ? _c('ul', {
      staticClass: "list-group",
      attrs: {
        "title": "Attacks"
      }
    }, _vm._l((player.attacks), function(attack) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_c('span', {
        staticClass: "attack-name"
      }, [_vm._v(_vm._s(attack.name) + ":")]), _vm._v(" "), _c('span', {
        staticClass: "label label-default",
        attrs: {
          "title": "Type"
        }
      }, [_vm._v(_vm._s(attack.type))]), _vm._v(" "), _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("Power: " + _vm._s(attack.power))]), _vm._v(" "), _c('span', {
        staticClass: "label label-warning",
        attrs: {
          "title": "Accuracy"
        }
      }, [_vm._v("Acc.: " + _vm._s(attack.accuracy))])])
    })) : _vm._e()])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9538c80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selection/index.vue
// module id = 125
// module chunks = 1